import React, { useEffect, useState } from "react";
import { fetchlocation } from "../util/fetch";
import styles from "./pages.module.css";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fromAddress,
  geocode,
  RequestType,
  fromLatLng,
  setLanguage,
  setRegion,
  setDefaults,
} from "react-geocode";
import { BASE_URL, GOOGLE_MAPS_API_KEY, SITE_URL } from "../config/config";
import { validateAddress } from "../config/validation";
import BudgetInfoModal from "../components/BudgetInfoModal";
import MapComponent from "../components/MapComponent";
import Loader from "../components/Loader";
import { calculateDistance } from "../util/calculateDistance";
import DirectionSteps from "../components/DirectionSteps";
import { Helmet } from "react-helmet";

const Locations = () => {
  const [locationData, setLocationData] = useState({
    bannerData: {},
    findNearestBudget: {},
  });
  const [budgetMarker, setBudgetMarker] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [instructions, setInstructions] = useState(null);
  //***FetchingData***
  useEffect(() => {
    // setBudgetMarker([]);
    document.title = "Locations | Budget Petrol";
    const fetchData = async () => {
      const response = await fetchlocation();
      setLocationData({
        ...locationData,
        bannerData: response.data.banner,
        findNearestBudget: response.data.findNearestBudget,
      });
    };
    fetchData();
    setDefaults({
      key: GOOGLE_MAPS_API_KEY,
      language: "en",
    });
    setRegion("au");
  }, []);
  const [initialCords, setInitialCords] = useState({
    lat: -31.2532183,
    lng: 146.921099,
  });
  // const [start, setStart] = useState({ lat: -31.2532183, lng: 146.921099 });
  const [destination, setDestination] = useState(null);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    address: "",
    radius: "10",
    results: "10",
  });
  const [storeLocations, setStoreLocations] = useState([]);
  const [zoom, setZoom] = useState(6);
  const [mapDisplay, setMapDisplay] = useState("markers");
  // const [contactFormData, setContactFormData] = useState();
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [infoType, setInfoType] = useState(" ");
  const [infoItem, setInfoItem] = useState({});
  const [noResults, setNoResults] = useState(false);
  const [validationError, setValError] = useState({
    invalidAddress: null,
  });
  const setModal = (info, item) => {
    setInfoModalVisible(true);
    setInfoType(info);
    setInfoItem(item);
    document.body.classList.add("no_scroll", "modal_set");
    document.getElementById("address_div").classList.add("no_scroll");
  };
  useEffect(() => {
    if (addresses.length == 40) {
      const sortedAddresses = addresses.sort((a, b) => a.distance - b.distance);
      setBudgetMarker(sortedAddresses);
    }
  }, [addresses]);
  useEffect(() => {
    const setPlaces = () => {
      if (locationData.findNearestBudget.fnb_address) {
        locationData.findNearestBudget.fnb_address.map((item, index) => {
          fromAddress(item.address).then(({ results, status }) => {
            if (status === "OK") {
              const { lat, lng } = results[0].geometry.location;
              const distance = calculateDistance(
                initialCords.lat,
                initialCords.lng,
                lat,
                lng
              );
              const roundedDistance = Math.round(distance * 100) / 100; // Round to two decimal places
              const formattedDistance = roundedDistance.toFixed(1);
              // setBudgetMarker((prev) => [
              //   ...prev,
              //   {
              //     title: item.title,
              //     address: item.address,
              //     callUs: item.callUs,
              //     openingHours: item.openingHours,
              //     serviceAvailable: item.serviceAvailable,
              //     productsAvailable: item.productsAvailable,
              //     distance: formattedDistance ? formattedDistance : "",
              //     latitude: lat,
              //     longitude: lng,
              //   },
              // ]);
              setAddresses((prev) => [
                ...prev,
                {
                  title: item.title,
                  address: item.address,
                  callUs: item.callUs,
                  openingHours: item.openingHours,
                  serviceAvailable: item.serviceAvailable,
                  productsAvailable: item.productsAvailable,
                  distance: formattedDistance ? formattedDistance : "",
                  latitude: lat,
                  longitude: lng,
                },
              ]);
              setStoreLocations((prev) => [
                ...prev,
                {
                  title: item.title,
                  address: item.address,
                  callUs: item.callUs,
                  openingHours: item.openingHours,
                  serviceAvailable: item.serviceAvailable,
                  productsAvailable: item.productsAvailable,
                  distance: formattedDistance ? formattedDistance : "",
                  latitude: lat,
                  longitude: lng,
                },
              ]);
              setMarkers((prevMarker) => [
                ...prevMarker,
                {
                  lat: lat,
                  lng: lng,
                  name: item.title,
                  vicinity: item.address,
                },
              ]);
            }
          });
        });
      }
    };
    setPlaces();
  }, [locationData.findNearestBudget]);
  useEffect(() => {
    if (formData.address === "") {
      const sortedLocations = storeLocations.sort(
        (a, b) => a.distance - b.distance
      );
      setBudgetMarker(sortedLocations);
      setMarkers([]);
      setZoom(6);
      setInitialCords({
        lat: -31.2532183,
        lng: 146.921099,
      });
      storeLocations.map((item, index) =>
        fromAddress(item.address).then(({ results, status }) => {
          if (status === "OK") {
            const { lat, lng } = results[0].geometry.location;
            setMarkers((prevMarker) => [
              ...prevMarker,
              {
                lat: lat,
                lng: lng,
                name: item.title,
                vicinity: item.address,
              },
            ]);
          }
        })
      );
      setNoResults(false);
    }
  }, [formData.address, storeLocations]);
  const handleForm = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    // console.log("HELLLOOO");
    if (validateAddress(data.address).success == true) {
      setValError({ invalidAddress: validateAddress(data.address).message });
    } else {
      // console.log("Address is Empty");
      setValError({ invalidAddress: validateAddress(data.address).message });
    }
    
    if (data.address && validateAddress(data.address).success == true) {
      setMarkers([]);
      setBudgetMarker([]);
      setLoading(true);
      setNoResults(false);
      setInitialCords(null);
      setMapDisplay("markers");
      fromAddress(data.address)
        .then(({ results, status }) => {
          if (status === "OK") {
            var count = 0;
            {results.map((item) => (
              item.address_components.map((value) => {
                if(value.long_name == 'New South Wales'){
                  const { lat, lng } = item.geometry.location;
                  //console.log(item.geometry.location)
                  if (!map) {
                    return;
                  }
                  const nearbyStoresDistance = storeLocations
                    .map((place) => {
                      const distance = calculateDistance(
                        lat,
                        lng,
                        place.latitude,
                        place.longitude
                      );
                      return {
                        ...place,
                        distance,
                      };
                    })
                    .filter((place) => place.distance <= data.radius);
                  const nearbyStores = nearbyStoresDistance.sort(
                    (a, b) => a.distance - b.distance
                  );
                  // .slice(0, data.results);
                  // console.log("BJWDsbnj", nearbyStores);
                  if (nearbyStores.length > 0) {
                    nearbyStores.map((item, index) => {
                      setMarkers((prevMarker) => [
                        ...prevMarker,
                        {
                          lat: item.latitude,
                          lng: item.longitude,
                          name: item.title,
                          vicinity: item.address,
                        },
                      ]);
                      const distance = calculateDistance(
                        lat,
                        lng,
                        item.latitude,
                        item.longitude
                      );
                      const roundedDistance = Math.round(distance * 100) / 100; // Round to two decimal places
                      const formattedDistance = roundedDistance.toFixed(1);
                      setBudgetMarker((prev) => [
                        ...prev,
                        {
                          title: item.title,
                          address: item.address,
                          callUs: item.callUs,
                          openingHours: item.openingHours,
                          serviceAvailable: item.serviceAvailable,
                          productsAvailable: item.productsAvailable,
                          distance: formattedDistance ? formattedDistance : "",
                          latitude: item.latitude,
                          longitude: item.longitude,
                        },
                      ]);
                    });
      
                    // setBudgetMarker(nearbyStores);
                    setLoading(false);
                    setInitialCords({ lat: lat, lng: lng });
                    if (nearbyStores.length === 1) {
                      setZoom(12);
                    } else if (nearbyStores.length > 1 && nearbyStores.length <= 5) {
                      setZoom(9);
                    } else if (nearbyStores.length > 5 && nearbyStores <= 10) {
                      setZoom(8.5);
                    } else if (
                      nearbyStores.length > 10 &&
                      nearbyStores.length <= 25
                    ) {
                      setZoom(8);
                    } else if (
                      nearbyStores.length > 25 &&
                      nearbyStores.length <= 40
                    ) {
                      setZoom(7.5);
                    }
                    count++;
                  } else {
                    // setNoResults(true);
                    // setLoading(false);
                  }
                }
              })
            ))}
            if(count == 0){
              setNoResults(true);
              setLoading(false);
            }
            // const { lat, lng } = results[0].geometry.location;
            // if (!map) {
            //   return;
            // }
            // const nearbyStoresDistance = storeLocations
            //   .map((place) => {
            //     const distance = calculateDistance(
            //       lat,
            //       lng,
            //       place.latitude,
            //       place.longitude
            //     );
            //     return {
            //       ...place,
            //       distance,
            //     };
            //   })
            //   .filter((place) => place.distance <= data.radius);
            // const nearbyStores = nearbyStoresDistance.sort(
            //   (a, b) => a.distance - b.distance
            // );
            // // .slice(0, data.results);
            // // console.log("BJWDsbnj", nearbyStores);
            // if (nearbyStores.length > 0) {
            //   nearbyStores.map((item, index) => {
            //     setMarkers((prevMarker) => [
            //       ...prevMarker,
            //       {
            //         lat: item.latitude,
            //         lng: item.longitude,
            //         name: item.title,
            //         vicinity: item.address,
            //       },
            //     ]);
            //     const distance = calculateDistance(
            //       lat,
            //       lng,
            //       item.latitude,
            //       item.longitude
            //     );
            //     const roundedDistance = Math.round(distance * 100) / 100; // Round to two decimal places
            //     const formattedDistance = roundedDistance.toFixed(1);
            //     setBudgetMarker((prev) => [
            //       ...prev,
            //       {
            //         title: item.title,
            //         address: item.address,
            //         callUs: item.callUs,
            //         openingHours: item.openingHours,
            //         serviceAvailable: item.serviceAvailable,
            //         productsAvailable: item.productsAvailable,
            //         distance: formattedDistance ? formattedDistance : "",
            //         latitude: item.latitude,
            //         longitude: item.longitude,
            //       },
            //     ]);
            //   });

            //   // setBudgetMarker(nearbyStores);
            //   setLoading(false);
            //   setInitialCords({ lat: lat, lng: lng });
            //   if (nearbyStores.length === 1) {
            //     setZoom(12);
            //   } else if (nearbyStores.length > 1 && nearbyStores.length <= 5) {
            //     setZoom(9);
            //   } else if (nearbyStores.length > 5 && nearbyStores <= 10) {
            //     setZoom(8.5);
            //   } else if (
            //     nearbyStores.length > 10 &&
            //     nearbyStores.length <= 25
            //   ) {
            //     setZoom(8);
            //   } else if (
            //     nearbyStores.length > 25 &&
            //     nearbyStores.length <= 40
            //   ) {
            //     setZoom(7.5);
            //   }
            // } else {
            //   setNoResults(true);
            //   setLoading(false);
            // }
          }
        })
        .catch((error) => {
          setNoResults(true);
          setLoading(false);
        });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  //***getting currentLocation of the user***
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        // console.log("Position :: ", position);
        const { latitude, longitude } = position.coords;
        setUserLocation({ lat: latitude, lng: longitude });
        // setInitialCords({ lat: latitude, lng: longitude });
      });
    }
  }, []);
  //*** Display Directions on Map ***
  const handleDirections = (latitude, longitude) => {
    setMapDisplay("directions");
    setDestination({ lat: latitude, lng: longitude });
  };
  return (
    <>
      <Helmet>
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Locations | Budget Petrol & Convenience Services in NSW"
        />
        <meta
          property="og:description"
          content="Explore GasCorp's network of petrol stations and convenience stores across NSW,Australia. Find your nearest GasCorp location in NSW for quality fuel and convenient shopping."
        />
        <meta property="og:url" content={`${SITE_URL}locations`} />
        <meta property="og:site_name" content="BUDGET PETROL" />
        <meta
          property="article:modified_time"
          content="2024-05-22T06:01:40+00:00"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Est. reading time" />
        <meta name="twitter:data1" content="2 minutes" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      {/* Banner Section */}
      <div
        className={styles.inner_banner_section}
        style={{
          backgroundImage: `url(${locationData.bannerData.banner_image})`,
        }}
      >
        <div className={styles.cotact_section}>
          <div className={styles.container}>
            <div className={styles.banner_heading}>
              <h1 className={styles.banner_txt}>
                {locationData.bannerData.banner_title}
              </h1>
              <div className={styles.breadcrumb_div}>
                <p>
                  <NavLink to="/">Home </NavLink>
                  <span>Locations</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Find Nearest Place Section */}
      <div
        className={`${styles.find_nearest_section} ${styles.contact_down} ${styles.update_partner}`}
      >
        <div className={styles.container}>
          <div className={styles.nearest_heading}>
            <h1 className={styles.nearest_txt}>
              Our
              <span> Locations</span>
            </h1>
          </div>
          <div className={`${styles.nearest_main} ${styles.locations_sec}`}>
            <div className={styles.nearest_img_sec}>
              <div className={styles.img_right}>
                <MapComponent
                  cords={initialCords}
                  places={markers}
                  infoAddress={locationData.findNearestBudget.fnb_address}
                  setMap={setMap}
                  zoom={zoom}
                  mode={mapDisplay}
                  destination={destination}
                  setInstructions={setInstructions}
                />
              </div>
            </div>
            <div className={styles.nearest_form_div}>
              <form className={styles.nearest_form} onSubmit={handleForm}>
                <div className={styles.locations_div}>
                  <label className={`${styles.form_label}`}>Postcode / Suburbs</label>
                  <input
                    placeholder="Postcode / Suburbs "
                    type="text"
                    className={
                      validationError.invalidAddress
                        ? `${styles.form_input} ${styles.input_error}`
                        : `${styles.form_input}`
                    } //styles.form_input
                    name="address"
                    value={formData.address}
                    onChange={(e) =>
                      setFormData({ ...formData, address: e.target.value })
                    }
                  />
                  {validationError.invalidAddress && (
                    <p className={styles.error_txt}>
                      {validationError.invalidAddress}
                    </p>
                  )}
                </div>
                <div className={styles.radius_div}>
                  <label className={styles.form_label}>Search Radius</label>
                  <select
                    className={styles.form_input}
                    // defaultValue={10}
                    value={formData.radius}
                    onChange={(e) =>
                      setFormData({ ...formData, radius: e.target.value })
                    }
                    name="radius"
                  >
                    <option value="10">10 km</option>
                    <option value="25">25 km</option>
                    <option value="50">50 km</option>
                    <option value="100">100 km</option>
                    <option value="200">200 km</option>
                    <option value="500">500 km</option>
                  </select>
                </div>
                {/* <div className={styles.result_div}>
                  <label className={styles.form_label}>Result</label> */}
                {/* <input
                    placeholder="10"
                    className={styles.form_input}
                    type="number"
                    value={formData.results}
                    onChange={(e) =>
                      setFormData({ ...formData, results: e.target.value })
                    }
                    name="results"
                  /> */}
                {/* <select
                    className={styles.form_input}
                    // defaultValue={10}
                    value={formData.results}
                    onChange={(e) =>
                      setFormData({ ...formData, results: e.target.value })
                    }
                    name="results"
                  >
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                  </select>
                </div> */}
                <div className={styles.submit_div}>
                  {/* <input type="submit" className={styles.submit_btn} /> */}
                  <button type="submit" className={styles.submit_btn}>
                    {" "}
                    Search
                  </button>
                </div>
              </form>
            </div>
            <div className={styles.address_section}>
              <div className={styles.nearest_address_sec} id="address_div">
                {loading && <Loader />}
                {noResults && (
                  <div className={styles.result_error}>
                    <p>No Results Found</p>
                  </div>
                )}
                {
                  budgetMarker.length > 0 &&
                    !loading &&
                    !noResults &&
                    mapDisplay === "markers" &&
                    budgetMarker.map((item, index) => (
                      <>
                        <div key={index} className={styles.nearest_place}>
                          <h3>{item.title}</h3>
                          <p className={styles.nearest_address}>
                            {item.address}
                          </p>
                          <p className={styles.nearest_phone}>
                            <span>Call Us:</span> {item.callUs}
                          </p>
                          <p className={styles.nearest_links}>
                            <a
                              href="javascript:void(0)"
                              onClick={() => setModal("hours", item)}
                            >
                              Opening Hours
                            </a>
                            <a
                              href="javascript:void(0)"
                              onClick={() => setModal("services", item)}
                            >
                              Services Available
                            </a>
                            <a
                              href="javascript:void(0)"
                              onClick={() => setModal("products", item)}
                            >
                              Products Available
                            </a>
                          </p>
                          <div className={styles.distance_section}>
                            <div className={styles.distance_txt}>
                              <p>{item.distance} km</p>
                            </div>
                            <div className={styles.section_directions}>
                              <p>
                                <a
                                  href="javascript:void(0)"
                                  onClick={() =>
                                    handleDirections(
                                      item.latitude,
                                      item.longitude
                                    )
                                  }
                                >
                                  Directions
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ))
                  // : locationData.findNearestBudget.fnb_address &&
                  //   !loading &&
                  //   !noResults &&
                  //   locationData.findNearestBudget.fnb_address.map(
                  //     (item, index) => (
                  //       <>
                  //         <div key={index} className={styles.nearest_place}>
                  //           <h3>{item.title}</h3>
                  //           <p className={styles.nearest_address}>
                  //             {item.address}
                  //           </p>
                  //           <p className={styles.nearest_phone}>
                  //             <span>Call Us:</span> {item.callUs}
                  //           </p>
                  //           <p className={styles.nearest_links}>
                  //             <a
                  //               href="javascript:void(0)"
                  //               onClick={() => setModal("hours", item)}
                  //             >
                  //               Opening Hours
                  //             </a>
                  //             <a
                  //               href="javascript:void(0)"
                  //               onClick={() => setModal("services", item)}
                  //             >
                  //               Services Available
                  //             </a>
                  //             <a
                  //               href="javascript:void(0)"
                  //               onClick={() => setModal("products", item)}
                  //             >
                  //               Products Available
                  //             </a>
                  //           </p>
                  //         </div>
                  //       </>
                  //     )
                  //   )
                }
                {mapDisplay === "directions" && instructions && (
                  <>
                    <DirectionSteps
                      instructions={instructions}
                      setMapDisplay={setMapDisplay}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BudgetInfoModal
        modalVisible={infoModalVisible}
        setModalVisible={setInfoModalVisible}
        item={infoItem}
        infoType={infoType}
      />
    </>
  );
};

export default React.memo(Locations);
